export default __webpack_public_path__ + "static/media/petals.3f60acf3.png";